var React = require('react');

function Video (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#081319;}")),React.createElement("path",{"d":"M13,11V23l11-6Zm1,1.91,8,4.15-8,4.1Z","key":1}),React.createElement("path",{"d":"M17,1A16,16,0,1,0,33,17,16,16,0,0,0,17,1Zm0,31A15,15,0,1,1,32,17,15,15,0,0,1,17,32Z","key":2})]);
}

Video.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34"};

module.exports = Video;

Video.default = Video;
